module.exports = __webpack_public_path__ + "img/badge-most-proposals-silver.f05fc4e4.png";